import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Home from "./reacttest/Home";
import Exercises from "./exercises/Exercises";
import Game from "./game/Game";

// Create a client
const queryClient = new QueryClient();

document.addEventListener("turbo:load", () => {
  const reactElements = document.querySelectorAll("[data-component]");

  reactElements.forEach((element) => {
    const componentName = element.dataset.component;
    const root = createRoot(element);

    // Render the appropriate component based on the data attribute
    const renderComponent = () => {
      switch (componentName) {
        case "reacttest/home":
          return <Home />;
        case "workout/exercises":
          return (
            <Exercises workoutId={parseInt(element.dataset.workoutId, 10)} />
          );
        case "game/index":
          return <Game />;
        default:
          return <div>Component not found: {componentName}</div>;
      }
    };

    root.render(
      <QueryClientProvider client={queryClient}>
        {renderComponent()}
      </QueryClientProvider>
    );
  });
});
